var _polygon, _polygon2, _path, _polygon3, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-52"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-52",
    cx: 249.05,
    cy: 347.57,
    rx: 189.51,
    ry: 99.06,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-52",
    d: "M251.35,370.44c-4.44,0-8.95-.19-13.4-.56-35.09-2.94-66.42-17.11-81.78-37l-.62-.79,14.21-11,.61.79c14.13,18.28,46.71,30.56,81.07,30.56h0c3.21,0,6.44-.11,9.59-.33,21.37-1.49,39.85-7.92,50.93-17.67l-10-10.86,35.45-2-3.12,37.07-10.14-11c-14.16,12.65-36.07,20.59-61.84,22.39C258.69,370.31,255,370.44,251.35,370.44Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 277.33 209.54 262.99 228.17 252.23 228.17 266.57 209.54 277.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 262.99 186.26 249.54 186.26 263.88 209.54 277.33 209.54 262.99",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 262.99 228.72 251.91 204.88 238.14 185.7 249.22 209.54 262.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 262.99 209.54 266.57 228.72 255.5 228.72 251.91 209.54 262.99",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 266.57 228.17 255.82 228.17 256.61 209.54 267.36 209.54 266.57",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.7 249.22 209.54 262.99 209.54 266.57 185.7 252.81 185.7 249.22",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 266.57 186.26 253.13 186.26 253.92 209.54 267.36 209.54 266.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,265.17l6.37-3.68c.27-.15.49,0,.49.29v3.76a1.1,1.1,0,0,1-.49.86l-6.37,3.68c-.27.16-.49,0-.49-.29V266A1.1,1.1,0,0,1,215.67,265.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.08,265.59l5.55-3.2c.18-.1.33,0,.33.19v2.82a.76.76,0,0,1-.33.58l-5.55,3.2c-.18.11-.33,0-.33-.19v-2.82A.76.76,0,0,1,216.08,265.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 261.19 209.54 246.85 228.17 236.09 228.17 250.43 209.54 261.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 246.85 186.26 233.4 186.26 247.74 209.54 261.19 209.54 246.85",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 246.85 228.72 235.77 204.88 222 185.7 233.08 209.54 246.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 246.85 209.54 250.43 228.72 239.36 228.72 235.77 209.54 246.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 250.43 228.17 239.68 228.17 240.46 209.54 251.22 209.54 250.43",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.7 233.08 209.54 246.85 209.54 250.43 185.7 236.67 185.7 233.08",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 250.43 186.26 236.99 186.26 237.78 209.54 251.22 209.54 250.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,249l6.37-3.68c.27-.16.49,0,.49.29v3.76a1.1,1.1,0,0,1-.49.86l-6.37,3.67c-.27.16-.49,0-.49-.28v-3.76A1.08,1.08,0,0,1,215.67,249Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.08,249.45l5.55-3.2c.18-.11.33,0,.33.19v2.82a.73.73,0,0,1-.33.57L216.08,253c-.18.1-.33,0-.33-.19V250A.74.74,0,0,1,216.08,249.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.17 251.01 209.54 261.19 187.26 248.31 186.72 248.64 209.54 261.77 227.71 251.33 227.17 251.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.17 251.01 209.54 261.19 187.26 248.31 186.72 248.64 209.54 261.77 227.71 251.33 227.17 251.01",
    style: {
      fill: "#e0e0e0",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 277.33 290.46 262.99 271.83 252.23 271.83 266.57 290.46 277.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 262.99 313.74 249.54 313.74 263.88 290.46 277.33 290.46 262.99",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 262.99 271.28 251.91 295.12 238.14 314.3 249.22 290.46 262.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 262.99 290.46 266.57 271.28 255.5 271.28 251.91 290.46 262.99",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 266.57 271.83 255.82 271.83 256.61 290.46 267.36 290.46 266.57",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.3 249.22 290.46 262.99 290.46 266.57 314.3 252.81 314.3 249.22",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 266.57 313.75 253.13 313.74 253.92 290.46 267.36 290.46 266.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,265.17,278,261.49c-.27-.15-.49,0-.49.29v3.76a1.1,1.1,0,0,0,.49.86l6.37,3.68c.27.16.49,0,.49-.29V266A1.1,1.1,0,0,0,284.33,265.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.92,265.59l-5.55-3.2c-.18-.1-.33,0-.33.19v2.82a.76.76,0,0,0,.33.58l5.55,3.2c.18.11.33,0,.33-.19v-2.82A.76.76,0,0,0,283.92,265.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 261.19 290.46 246.85 271.83 236.09 271.83 250.43 290.46 261.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 246.85 313.74 233.4 313.74 247.74 290.46 261.19 290.46 246.85",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 246.85 271.28 235.77 295.12 222 314.3 233.08 290.46 246.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 246.85 290.46 250.43 271.28 239.36 271.28 235.77 290.46 246.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 250.43 271.83 239.68 271.83 240.46 290.46 251.22 290.46 250.43",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.3 233.08 290.46 246.85 290.46 250.43 314.3 236.67 314.3 233.08",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.46 250.43 313.75 236.99 313.74 237.78 290.46 251.22 290.46 250.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,249,278,245.35c-.27-.16-.49,0-.49.29v3.76a1.1,1.1,0,0,0,.49.86l6.37,3.67c.27.16.49,0,.49-.28v-3.76A1.08,1.08,0,0,0,284.33,249Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.92,249.45l-5.55-3.2c-.18-.11-.33,0-.33.19v2.82a.73.73,0,0,0,.33.57l5.55,3.21c.18.1.33,0,.33-.19V250A.74.74,0,0,0,283.92,249.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.83 251.01 290.46 261.19 312.74 248.31 313.28 248.64 290.46 261.77 272.29 251.33 272.83 251.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.83 251.01 290.46 261.19 312.74 248.31 313.28 248.64 290.46 261.77 272.29 251.33 272.83 251.01",
    style: {
      fill: "#e0e0e0",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinets--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "64.18 335.41 86.45 322.56 86.45 274.81 64.18 287.66 64.18 335.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.18 287.66 32.37 269.3 32.37 317.05 64.18 335.41 64.18 287.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.37 269.3 64.18 287.66 86.45 274.81 54.64 256.44 32.37 269.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.59 311.88 36.14 297.19 36.14 314.87 35.55 315.21 61 329.9 61.59 329.56 61.59 311.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61 312.22 35.55 297.52 35.55 315.21 61 329.9 61 312.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,309.45,46.7,307c-.56-.33-1-.18-1,.33a2,2,0,0,0,1,1.5l4.33,2.5c.56.33,1,.18,1-.33A2,2,0,0,0,51,309.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.59 290.53 36.14 275.84 36.14 293.52 35.55 293.86 61 308.55 61.59 308.21 61.59 290.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61 290.87 35.55 276.18 35.55 293.86 61 308.55 61 290.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,288.11l-4.33-2.5c-.56-.33-1-.18-1,.33a2,2,0,0,0,1,1.5l4.33,2.5c.56.33,1,.18,1-.33A2,2,0,0,0,51,288.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "435.82 335.41 413.55 322.56 413.55 274.81 435.82 287.66 435.82 335.41",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "435.82 335.41 413.55 322.56 413.55 274.81 435.82 287.66 435.82 335.41"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "435.82 287.66 467.63 269.3 467.63 317.05 435.82 335.41 435.82 287.66",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.63 269.3 435.82 287.66 413.55 274.81 445.36 256.44 467.63 269.3",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "467.63 269.3 435.82 287.66 413.55 274.81 445.36 256.44 467.63 269.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "438.42 311.88 463.86 297.19 463.86 314.87 464.44 315.21 439 329.9 438.41 329.56 438.42 311.88",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.42 311.88 463.86 297.19 463.86 314.87 464.44 315.21 439 329.9 438.41 329.56 438.42 311.88"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "439 312.22 464.45 297.52 464.44 315.21 439 329.9 439 312.22",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439 312.22 464.45 297.52 464.44 315.21 439 329.9 439 312.22",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449,309.45,453.3,307c.56-.33,1-.18,1,.33a2,2,0,0,1-1,1.5l-4.33,2.5c-.56.33-1,.18-1-.33A2,2,0,0,1,449,309.45Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449,309.45,453.3,307c.56-.33,1-.18,1,.33a2,2,0,0,1-1,1.5l-4.33,2.5c-.56.33-1,.18-1-.33A2,2,0,0,1,449,309.45Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "438.42 290.53 463.86 275.84 463.86 293.52 464.44 293.86 439 308.55 438.41 308.21 438.42 290.53",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.42 290.53 463.86 275.84 463.86 293.52 464.44 293.86 439 308.55 438.41 308.21 438.42 290.53"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "439 290.87 464.45 276.18 464.44 293.86 439 308.55 439 290.87",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439 290.87 464.45 276.18 464.44 293.86 439 308.55 439 290.87",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449,288.11l4.33-2.5c.56-.33,1-.18,1,.33a2,2,0,0,1-1,1.5l-4.33,2.5c-.56.33-1,.18-1-.33A2,2,0,0,1,449,288.11Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M449,288.11l4.33-2.5c.56-.33,1-.18,1,.33a2,2,0,0,1-1,1.5l-4.33,2.5c-.56.33-1,.18-1-.33A2,2,0,0,1,449,288.11Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folders--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder-black--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.58,273.76l104.1,60.11,6.33,3.65.29.15a3.44,3.44,0,0,0,.53.21,3.08,3.08,0,0,0,.66.18,3.11,3.11,0,0,0,.44.08.13.13,0,0,0,.09,0,5.12,5.12,0,0,0,.56,0,3.4,3.4,0,0,0,1.66-.36,6.19,6.19,0,0,0,2.37-3.77l17.54-91.14a3,3,0,0,0,.06-.6,2.7,2.7,0,0,0,0-.49v0a4.43,4.43,0,0,0-.17-.74,7.8,7.8,0,0,0-.31-.72l-.26-.43a4.94,4.94,0,0,0-.36-.44,3.82,3.82,0,0,0-.36-.34,3.93,3.93,0,0,0-.42-.29L326.87,175.09a2.64,2.64,0,0,0-.29-.15l-.31-.14a.66.66,0,0,0-.15-.05,1.39,1.39,0,0,0-.4,0,5,5,0,0,0-2,.92l-2.45,1.44h0a1.27,1.27,0,0,0-.49.35,1.88,1.88,0,0,0-.45.75,2,2,0,0,0-.1.38l-17.55,91.13A4.13,4.13,0,0,0,304.58,273.76Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,273.76l104.1,60.11,6.33,3.65.29.15a3.44,3.44,0,0,0,.53.21,3.08,3.08,0,0,0,.66.18,3.11,3.11,0,0,0,.44.08.13.13,0,0,0,.09,0,5.12,5.12,0,0,0,.56,0,3.4,3.4,0,0,0,1.66-.36,6.19,6.19,0,0,0,2.37-3.77l17.54-91.14a3,3,0,0,0,.06-.6,2.7,2.7,0,0,0,0-.49v0a4.43,4.43,0,0,0-.17-.74,7.8,7.8,0,0,0-.31-.72l-.26-.43a4.94,4.94,0,0,0-.36-.44,3.82,3.82,0,0,0-.36-.34,3.93,3.93,0,0,0-.42-.29L326.87,175.09a2.64,2.64,0,0,0-.29-.15l-.31-.14a.66.66,0,0,0-.15-.05,1.39,1.39,0,0,0-.4,0,5,5,0,0,0-2,.92l-2.45,1.44h0a1.27,1.27,0,0,0-.49.35,1.88,1.88,0,0,0-.45.75,2,2,0,0,0-.1.38l-17.55,91.13A4.13,4.13,0,0,0,304.58,273.76Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.3,337.67a4.68,4.68,0,0,0,3.94.15,6.19,6.19,0,0,0,2.37-3.77l17.54-91.14a4,4,0,0,0-.46-2.57L435,242.48a4.06,4.06,0,0,1,.47,2.57L417.9,336.2A1.81,1.81,0,0,1,415.3,337.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.76,175.63l-2.45,1.44h0a1.94,1.94,0,0,1,1.85.16L433.58,241a3.78,3.78,0,0,1,1.39,1.49l3.72-2.14-.26-.43a4.94,4.94,0,0,0-.36-.44,3.65,3.65,0,0,0-.78-.63L326.87,175.09a4.15,4.15,0,0,0-.6-.29.66.66,0,0,0-.15-.05,1.39,1.39,0,0,0-.4,0A5,5,0,0,0,323.76,175.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.76,175.63l-2.45,1.44h0a1.94,1.94,0,0,1,1.85.16L433.58,241a3.78,3.78,0,0,1,1.39,1.49l3.72-2.14-.26-.43a4.94,4.94,0,0,0-.36-.44,3.65,3.65,0,0,0-.78-.63L326.87,175.09a4.15,4.15,0,0,0-.6-.29.66.66,0,0,0-.15-.05,1.39,1.39,0,0,0-.4,0A5,5,0,0,0,323.76,175.63Z",
    style: {
      fill: "#455a64",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.9,336.19l17.54-91.13a4.14,4.14,0,0,0-1.86-4.07L323.16,177.24a1.83,1.83,0,0,0-2.9,1.32L302.72,269.7a4.14,4.14,0,0,0,1.86,4.07L415,337.52A1.84,1.84,0,0,0,417.9,336.19Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.9,336.19l17.54-91.13a4.14,4.14,0,0,0-1.86-4.07L323.16,177.24a1.83,1.83,0,0,0-2.9,1.32L302.72,269.7a4.14,4.14,0,0,0,1.86,4.07L415,337.52A1.84,1.84,0,0,0,417.9,336.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.9,336.19l17.54-91.13a4.14,4.14,0,0,0-1.86-4.07L323.16,177.24a1.83,1.83,0,0,0-2.9,1.32L302.72,269.7a4.14,4.14,0,0,0,1.86,4.07L415,337.52A1.84,1.84,0,0,0,417.9,336.19Z",
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.19,270.08l74.89,43.24,4.55,2.63.21.11a3,3,0,0,0,.38.15,2.62,2.62,0,0,0,.48.13,1.67,1.67,0,0,0,.31.05.09.09,0,0,0,.07,0,2.69,2.69,0,0,0,.4,0,2.47,2.47,0,0,0,1.2-.27,4.46,4.46,0,0,0,1.7-2.71L431,247.89a2.09,2.09,0,0,0,0-.43,2.19,2.19,0,0,0,0-.36h0a2.48,2.48,0,0,0-.12-.54,4.61,4.61,0,0,0-.22-.51c-.06-.1-.12-.21-.19-.31a1.94,1.94,0,0,0-.26-.31,1.23,1.23,0,0,0-.26-.25,2.64,2.64,0,0,0-.29-.21L350.23,199.1,350,199l-.23-.1a.29.29,0,0,0-.1,0,1,1,0,0,0-.29,0,3.57,3.57,0,0,0-1.41.67l-1.76,1h0a1,1,0,0,0-.36.25,1.39,1.39,0,0,0-.32.54,1.8,1.8,0,0,0-.07.27l-12.62,65.57A3,3,0,0,0,334.19,270.08Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.19,270.08l74.89,43.24,4.55,2.63.21.11a3,3,0,0,0,.38.15,2.62,2.62,0,0,0,.48.13,1.67,1.67,0,0,0,.31.05.09.09,0,0,0,.07,0,2.69,2.69,0,0,0,.4,0,2.47,2.47,0,0,0,1.2-.27,4.46,4.46,0,0,0,1.7-2.71L431,247.89a2.09,2.09,0,0,0,0-.43,2.19,2.19,0,0,0,0-.36h0a2.48,2.48,0,0,0-.12-.54,4.61,4.61,0,0,0-.22-.51c-.06-.1-.12-.21-.19-.31a1.94,1.94,0,0,0-.26-.31,1.23,1.23,0,0,0-.26-.25,2.64,2.64,0,0,0-.29-.21L350.23,199.1,350,199l-.23-.1a.29.29,0,0,0-.1,0,1,1,0,0,0-.29,0,3.57,3.57,0,0,0-1.41.67l-1.76,1h0a1,1,0,0,0-.36.25,1.39,1.39,0,0,0-.32.54,1.8,1.8,0,0,0-.07.27l-12.62,65.57A3,3,0,0,0,334.19,270.08Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.84,316.06a3.38,3.38,0,0,0,2.84.1,4.46,4.46,0,0,0,1.7-2.71L431,247.89a3,3,0,0,0-.33-1.85L428,247.58a2.9,2.9,0,0,1,.34,1.85L415.71,315A1.3,1.3,0,0,1,413.84,316.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,199.49l-1.76,1h0a1.35,1.35,0,0,1,1.32.12L427,246.51a2.59,2.59,0,0,1,1,1.07l2.68-1.54c-.06-.1-.12-.21-.19-.31a1.94,1.94,0,0,0-.26-.31,2.4,2.4,0,0,0-.55-.46L350.23,199.1a3.55,3.55,0,0,0-.44-.21.29.29,0,0,0-.1,0,1,1,0,0,0-.29,0A3.57,3.57,0,0,0,348,199.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.71,315l12.62-65.57a3,3,0,0,0-1.34-2.92l-79.43-45.87a1.32,1.32,0,0,0-2.09,1l-12.61,65.57a3,3,0,0,0,1.33,2.92L413.63,316A1.32,1.32,0,0,0,415.71,315Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357,250.8a2.3,2.3,0,0,0,1-1.83V129.74a2.37,2.37,0,0,0-1.08-1.87L282,84.63a2,2,0,0,0-3.1,1.8V205.66a2.37,2.37,0,0,0,1.08,1.87l74.87,43.24A2.32,2.32,0,0,0,357,250.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,86.24c.1-.55.54-.74,1.08-.43L354.87,129a2.13,2.13,0,0,1,.76.81l2-1.17a2.34,2.34,0,0,0-.77-.82L282,84.64a2.32,2.32,0,0,0-2.1,0A2.43,2.43,0,0,0,278.91,86.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,250.84a2.33,2.33,0,0,0,1.95,0,2.3,2.3,0,0,0,1-1.83V129.74a2.23,2.23,0,0,0-.31-1.06l-2,1.17a2.14,2.14,0,0,1,.32,1.06V250.14C356,250.77,355.53,251.07,355,250.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.86,250.77,280,207.53a2.37,2.37,0,0,1-1.08-1.87V86.43c0-.69.48-1,1.08-.62L354.86,129a2.37,2.37,0,0,1,1.08,1.87V250.14C355.94,250.83,355.46,251.11,354.86,250.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.48,183.35c0,.92-.83,1.19-1.84.6l-62.43-36a3.71,3.71,0,0,1-1.84-2.72c0-.92.83-1.19,1.84-.6l62.43,36A3.71,3.71,0,0,1,350.48,183.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,193.31c0,.91-.83,1.18-1.84.6l-62.43-36a3.68,3.68,0,0,1-1.84-2.72c0-.92.83-1.18,1.84-.6l62.43,36.05A3.68,3.68,0,0,1,350.48,193.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,203.26c0,.92-.83,1.19-1.84.6l-62.43-36a3.71,3.71,0,0,1-1.84-2.72c0-.92.83-1.19,1.84-.6l62.43,36A3.71,3.71,0,0,1,350.48,203.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,213.22c0,.92-.83,1.18-1.84.6l-62.43-36a3.68,3.68,0,0,1-1.84-2.72c0-.91.83-1.18,1.84-.6l62.43,36.05A3.68,3.68,0,0,1,350.48,213.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,153.48c0,.92-.83,1.19-1.84.6l-62.43-36a3.71,3.71,0,0,1-1.84-2.72c0-.92.83-1.19,1.84-.6l62.43,36A3.71,3.71,0,0,1,350.48,153.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,163.44c0,.92-.83,1.18-1.84.6l-62.43-36a3.68,3.68,0,0,1-1.84-2.72c0-.91.83-1.18,1.84-.59l62.43,36A3.7,3.7,0,0,1,350.48,163.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,143.54c0,.92-.83,1.19-1.84.6l-62.43-36a3.71,3.71,0,0,1-1.84-2.72c0-.92.83-1.19,1.84-.6l62.43,36A3.71,3.71,0,0,1,350.48,143.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,173.4c0,.91-.83,1.18-1.84.59l-62.43-36a3.7,3.7,0,0,1-1.84-2.72c0-.92.83-1.19,1.84-.6l62.43,36A3.71,3.71,0,0,1,350.48,173.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,223.18c0,.91-.83,1.18-1.84.59l-62.43-36a3.71,3.71,0,0,1-1.84-2.72c0-.92.83-1.19,1.84-.6l62.43,36A3.71,3.71,0,0,1,350.48,223.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,233.13c0,.92-.83,1.19-1.84.6l-62.43-36a3.68,3.68,0,0,1-1.84-2.72c0-.91.83-1.18,1.84-.59l62.43,36A3.7,3.7,0,0,1,350.48,233.13Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M300.12,187.05a1.75,1.75,0,0,1,.68-1.56,1.15,1.15,0,0,1,.17-.11l3.58-2.08h0a1.73,1.73,0,0,1,1.74.18l71.57,41.27,2.09-8.41a2.33,2.33,0,0,1,1-1.37h0l3.72-2.17v0a2.19,2.19,0,0,1,2.26.06l30.45,17.57a5.47,5.47,0,0,1,2.48,4.29V336.27a1.76,1.76,0,0,1-.67,1.56h0l-3.83,2.23h0a1.78,1.78,0,0,1-1.69-.21L302.55,275.68a5.47,5.47,0,0,1-2.48-4.29Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,214.93a2.19,2.19,0,0,1,2.22.1L413.7,232.6a5.2,5.2,0,0,1,1.75,1.85l3.71-2.16a5,5,0,0,0-1.75-1.85L387,212.87a2.21,2.21,0,0,0-2.27-.06h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,185.38a1.89,1.89,0,0,1,1.63.24L374.24,227a2.16,2.16,0,0,0,3.3-1.31l.33-.9-71.56-41.28a2.19,2.19,0,0,0-1.1-.33,1.32,1.32,0,0,0-.64.16h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.12,187.06l-.05,84.33a5.47,5.47,0,0,0,2.48,4.29L414,340a1.46,1.46,0,0,0,2.19-1.27V236.89a5,5,0,0,0-.72-2.43,5.21,5.21,0,0,0-1.75-1.85L383.26,215a2.22,2.22,0,0,0-2.22-.1l-.07,0h0a2.31,2.31,0,0,0-1,1.37l-2.09,8.4-.33.91a2.16,2.16,0,0,1-3.3,1.31L302.6,185.63a1.84,1.84,0,0,0-1.62-.24l-.1.06-.06,0,0,0A1.77,1.77,0,0,0,300.12,187.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.06,268.11a1.19,1.19,0,0,1,1.57.56l3.32,7V263.22a1.18,1.18,0,1,1,2.35,0v15l3.58-3.44a1.16,1.16,0,0,1,1.66,0,1.18,1.18,0,0,1,0,1.66l-5.56,5.35a1.17,1.17,0,0,1-1,.31,1.15,1.15,0,0,1-.84-.66l-5.57-11.77A1.18,1.18,0,0,1,352.06,268.11Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,270.78a1.17,1.17,0,0,1-1.18-1.17v-7.08l-13.63-7.87v5.73a1.17,1.17,0,0,1-2.34,0v-7.76a1.16,1.16,0,0,1,.58-1,1.14,1.14,0,0,1,.59-.16,1.16,1.16,0,0,1,.59.16l16,9.22a1.17,1.17,0,0,1,.59,1v7.75A1.17,1.17,0,0,1,366.12,270.78Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.28,340.09a.23.23,0,0,0,.11,0l3.83-2.22a1.82,1.82,0,0,0,.67-1.58V234.73a5,5,0,0,0-.73-2.44l-3.71,2.16h0a5,5,0,0,1,.73,2.44V338.75A1.44,1.44,0,0,1,415.28,340.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder-green--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.42,273.76,91.32,333.87,85,337.52l-.29.15a3.44,3.44,0,0,1-.53.21,3.08,3.08,0,0,1-.66.18,3.11,3.11,0,0,1-.44.08.13.13,0,0,1-.09,0,5.12,5.12,0,0,1-.56,0,3.4,3.4,0,0,1-1.66-.36,6.19,6.19,0,0,1-2.37-3.77L60.85,242.91a3,3,0,0,1-.06-.6,2.7,2.7,0,0,1,0-.49v0a4.43,4.43,0,0,1,.17-.74,7.8,7.8,0,0,1,.31-.72l.26-.43a4.94,4.94,0,0,1,.36-.44,3.82,3.82,0,0,1,.36-.34,3.93,3.93,0,0,1,.42-.29l110.42-63.75a2.64,2.64,0,0,1,.29-.15l.31-.14a.66.66,0,0,1,.15-.05,1.39,1.39,0,0,1,.4,0,5,5,0,0,1,2,.92l2.45,1.44h0a1.27,1.27,0,0,1,.49.35,1.88,1.88,0,0,1,.45.75,2,2,0,0,1,.1.38l17.55,91.13A4.13,4.13,0,0,1,195.42,273.76Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.42,273.76,91.32,333.87,85,337.52l-.29.15a3.44,3.44,0,0,1-.53.21,3.08,3.08,0,0,1-.66.18,3.11,3.11,0,0,1-.44.08.13.13,0,0,1-.09,0,5.12,5.12,0,0,1-.56,0,3.4,3.4,0,0,1-1.66-.36,6.19,6.19,0,0,1-2.37-3.77L60.85,242.91a3,3,0,0,1-.06-.6,2.7,2.7,0,0,1,0-.49v0a4.43,4.43,0,0,1,.17-.74,7.8,7.8,0,0,1,.31-.72l.26-.43a4.94,4.94,0,0,1,.36-.44,3.82,3.82,0,0,1,.36-.34,3.93,3.93,0,0,1,.42-.29l110.42-63.75a2.64,2.64,0,0,1,.29-.15l.31-.14a.66.66,0,0,1,.15-.05,1.39,1.39,0,0,1,.4,0,5,5,0,0,1,2,.92l2.45,1.44h0a1.27,1.27,0,0,1,.49.35,1.88,1.88,0,0,1,.45.75,2,2,0,0,1,.1.38l17.55,91.13A4.13,4.13,0,0,1,195.42,273.76Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,337.67a4.68,4.68,0,0,1-3.94.15,6.19,6.19,0,0,1-2.37-3.77L60.85,242.91a4,4,0,0,1,.46-2.57L65,242.48a4.06,4.06,0,0,0-.47,2.57L82.1,336.2A1.81,1.81,0,0,0,84.7,337.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,175.63l2.45,1.44h0a1.94,1.94,0,0,0-1.85.16L66.42,241A3.78,3.78,0,0,0,65,242.48l-3.72-2.14.26-.43a4.94,4.94,0,0,1,.36-.44,3.65,3.65,0,0,1,.78-.63l110.42-63.75a4.15,4.15,0,0,1,.6-.29.66.66,0,0,1,.15-.05,1.39,1.39,0,0,1,.4,0A5,5,0,0,1,176.24,175.63Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,336.19,64.56,245.06A4.14,4.14,0,0,1,66.42,241l110.42-63.75a1.83,1.83,0,0,1,2.9,1.32l17.54,91.14a4.14,4.14,0,0,1-1.86,4.07L85,337.52A1.84,1.84,0,0,1,82.1,336.19Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,336.19,64.56,245.06A4.14,4.14,0,0,1,66.42,241l110.42-63.75a1.83,1.83,0,0,1,2.9,1.32l17.54,91.14a4.14,4.14,0,0,1-1.86,4.07L85,337.52A1.84,1.84,0,0,1,82.1,336.19Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.81,270.08,90.92,313.32,86.37,316l-.21.11a3,3,0,0,1-.38.15,2.62,2.62,0,0,1-.48.13,1.67,1.67,0,0,1-.31.05.09.09,0,0,1-.07,0,2.69,2.69,0,0,1-.4,0,2.47,2.47,0,0,1-1.2-.27,4.46,4.46,0,0,1-1.7-2.71L69,247.89a2.09,2.09,0,0,1,0-.43,2.19,2.19,0,0,1,0-.36h0a2.48,2.48,0,0,1,.12-.54,4.61,4.61,0,0,1,.22-.51c.06-.1.12-.21.19-.31a1.94,1.94,0,0,1,.26-.31,1.23,1.23,0,0,1,.26-.25,2.64,2.64,0,0,1,.29-.21l79.44-45.86L150,199l.23-.1a.29.29,0,0,1,.1,0,1,1,0,0,1,.29,0,3.57,3.57,0,0,1,1.41.67l1.76,1h0a1,1,0,0,1,.36.25,1.39,1.39,0,0,1,.32.54,1.8,1.8,0,0,1,.07.27l12.62,65.57A3,3,0,0,1,165.81,270.08Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.81,270.08,90.92,313.32,86.37,316l-.21.11a3,3,0,0,1-.38.15,2.62,2.62,0,0,1-.48.13,1.67,1.67,0,0,1-.31.05.09.09,0,0,1-.07,0,2.69,2.69,0,0,1-.4,0,2.47,2.47,0,0,1-1.2-.27,4.46,4.46,0,0,1-1.7-2.71L69,247.89a2.09,2.09,0,0,1,0-.43,2.19,2.19,0,0,1,0-.36h0a2.48,2.48,0,0,1,.12-.54,4.61,4.61,0,0,1,.22-.51c.06-.1.12-.21.19-.31a1.94,1.94,0,0,1,.26-.31,1.23,1.23,0,0,1,.26-.25,2.64,2.64,0,0,1,.29-.21l79.44-45.86L150,199l.23-.1a.29.29,0,0,1,.1,0,1,1,0,0,1,.29,0,3.57,3.57,0,0,1,1.41.67l1.76,1h0a1,1,0,0,1,.36.25,1.39,1.39,0,0,1,.32.54,1.8,1.8,0,0,1,.07.27l12.62,65.57A3,3,0,0,1,165.81,270.08Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.16,316.06a3.38,3.38,0,0,1-2.84.1,4.46,4.46,0,0,1-1.7-2.71L69,247.89a3,3,0,0,1,.33-1.85L72,247.58a2.9,2.9,0,0,0-.34,1.85L84.29,315A1.3,1.3,0,0,0,86.16,316.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,199.49l1.76,1h0a1.35,1.35,0,0,0-1.32.12L73,246.51a2.59,2.59,0,0,0-1,1.07L69.33,246c.06-.1.12-.21.19-.31a1.94,1.94,0,0,1,.26-.31,2.4,2.4,0,0,1,.55-.46l79.44-45.86a3.55,3.55,0,0,1,.44-.21.29.29,0,0,1,.1,0,1,1,0,0,1,.29,0A3.57,3.57,0,0,1,152,199.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.29,315,71.67,249.43A3,3,0,0,1,73,246.51l79.43-45.87a1.32,1.32,0,0,1,2.09,1l12.61,65.57a3,3,0,0,1-1.33,2.92L86.37,316A1.32,1.32,0,0,1,84.29,315Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--document--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143,250.8a2.3,2.3,0,0,1-1-1.83V129.74a2.37,2.37,0,0,1,1.08-1.87L218,84.63a2,2,0,0,1,3.1,1.8V205.66a2.37,2.37,0,0,1-1.08,1.87l-74.87,43.24A2.32,2.32,0,0,1,143,250.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09,86.24c-.1-.55-.54-.74-1.07-.43L145.13,129a2.13,2.13,0,0,0-.76.81l-2-1.17a2.34,2.34,0,0,1,.77-.82L218,84.64a2.32,2.32,0,0,1,2.1,0A2.43,2.43,0,0,1,221.09,86.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,250.84a2.33,2.33,0,0,1-2,0,2.3,2.3,0,0,1-1-1.83V129.74a2.23,2.23,0,0,1,.31-1.06l2,1.17a2.14,2.14,0,0,0-.32,1.06V250.14C144.05,250.77,144.47,251.07,145,250.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.14,250.77,220,207.53a2.37,2.37,0,0,0,1.08-1.87V86.43c0-.69-.48-1-1.08-.62L145.14,129a2.37,2.37,0,0,0-1.08,1.87V250.14C144.06,250.83,144.54,251.11,145.14,250.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.52,183.35c0,.92.83,1.19,1.84.6l62.43-36a3.71,3.71,0,0,0,1.84-2.72c0-.92-.83-1.19-1.84-.6l-62.43,36A3.71,3.71,0,0,0,149.52,183.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,193.31c0,.91.83,1.18,1.84.6l62.43-36a3.68,3.68,0,0,0,1.84-2.72c0-.92-.83-1.18-1.84-.6l-62.43,36.05A3.68,3.68,0,0,0,149.52,193.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,203.26c0,.92.83,1.19,1.84.6l62.43-36a3.71,3.71,0,0,0,1.84-2.72c0-.92-.83-1.19-1.84-.6l-62.43,36A3.71,3.71,0,0,0,149.52,203.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,213.22c0,.92.83,1.18,1.84.6l62.43-36a3.68,3.68,0,0,0,1.84-2.72c0-.91-.83-1.18-1.84-.6L151.36,210.5A3.68,3.68,0,0,0,149.52,213.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,153.48c0,.92.83,1.19,1.84.6l62.43-36a3.71,3.71,0,0,0,1.84-2.72c0-.92-.83-1.19-1.84-.6l-62.43,36A3.71,3.71,0,0,0,149.52,153.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,163.44c0,.92.83,1.18,1.84.6l62.43-36a3.68,3.68,0,0,0,1.84-2.72c0-.91-.83-1.18-1.84-.59l-62.43,36A3.7,3.7,0,0,0,149.52,163.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,143.54c0,.92.83,1.19,1.84.6l62.43-36a3.71,3.71,0,0,0,1.84-2.72c0-.92-.83-1.19-1.84-.6l-62.43,36A3.71,3.71,0,0,0,149.52,143.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,173.4c0,.91.83,1.18,1.84.59l62.43-36a3.7,3.7,0,0,0,1.84-2.72c0-.92-.83-1.19-1.84-.6l-62.43,36A3.71,3.71,0,0,0,149.52,173.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,223.18c0,.91.83,1.18,1.84.59l62.43-36a3.71,3.71,0,0,0,1.84-2.72c0-.92-.83-1.19-1.84-.6l-62.43,36A3.71,3.71,0,0,0,149.52,223.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,233.13c0,.92.83,1.19,1.84.6l62.43-36a3.68,3.68,0,0,0,1.84-2.72c0-.91-.83-1.18-1.84-.59l-62.43,36A3.7,3.7,0,0,0,149.52,233.13Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,187.05a1.75,1.75,0,0,0-.68-1.56,1.15,1.15,0,0,0-.17-.11l-3.58-2.08h0a1.73,1.73,0,0,0-1.74.18l-71.57,41.27L120,216.33a2.33,2.33,0,0,0-1-1.37h0l-3.72-2.17v0a2.19,2.19,0,0,0-2.26.06L82.59,230.44a5.47,5.47,0,0,0-2.48,4.29V336.27a1.76,1.76,0,0,0,.67,1.56h0l3.83,2.23h0a1.78,1.78,0,0,0,1.69-.21l111.15-64.17a5.47,5.47,0,0,0,2.48-4.29Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,214.93a2.19,2.19,0,0,0-2.22.1L86.3,232.6a5.2,5.2,0,0,0-1.75,1.85l-3.71-2.16a5,5,0,0,1,1.75-1.85L113,212.87a2.21,2.21,0,0,1,2.27-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,185.38a1.89,1.89,0,0,0-1.63.24L125.77,227a2.17,2.17,0,0,1-3.31-1.31l-.33-.9,71.57-41.28a2.13,2.13,0,0,1,1.09-.33,1.32,1.32,0,0,1,.64.16h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,187.06l.05,84.33a5.47,5.47,0,0,1-2.48,4.29L86,340a1.46,1.46,0,0,1-2.19-1.27V236.89a5,5,0,0,1,.72-2.43,5.21,5.21,0,0,1,1.75-1.85L116.74,215a2.22,2.22,0,0,1,2.22-.1l.07,0h0a2.31,2.31,0,0,1,1,1.37l2.09,8.4.33.91a2.16,2.16,0,0,0,3.3,1.31l71.64-41.33a1.84,1.84,0,0,1,1.62-.24l.1.06.06,0,0,0A1.77,1.77,0,0,1,199.88,187.06Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.81,265.47a1.25,1.25,0,0,0,.5.11,1.18,1.18,0,0,0,1.06-.67l3.33-7.05v12.5a1.18,1.18,0,0,0,2.35,0v-15l3.57,3.44a1.17,1.17,0,0,0,1.63-1.69l-5.56-5.35a1.18,1.18,0,0,0-1.88.34l-5.56,11.78A1.17,1.17,0,0,0,135.81,265.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.86,261.79a1.17,1.17,0,0,0-1.17,1.17V270l-13.63,7.87v-5.72a1.18,1.18,0,0,0-2.35,0v7.75a1.17,1.17,0,0,0,.59,1,1.15,1.15,0,0,0,1.17,0l16-9.23a1.16,1.16,0,0,0,.58-1V263A1.17,1.17,0,0,0,149.86,261.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.72,340.09a.23.23,0,0,1-.11,0l-3.83-2.22a1.82,1.82,0,0,1-.67-1.58V234.73a5,5,0,0,1,.73-2.44l3.71,2.16h0a5,5,0,0,0-.73,2.44V338.75A1.44,1.44,0,0,0,84.72,340.09Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "304.12 315.25 304.12 322.87 333.47 354.69 333.47 347.07 304.12 315.25",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.12 315.25 304.12 322.87 333.47 354.69 333.47 347.07 304.12 315.25",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.31 321.04 336.31 313.42 333.47 347.07 333.47 354.69 336.31 321.04",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.31 321.04 336.31 313.42 333.47 347.07 333.47 354.69 336.31 321.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,366.63C203.23,363.76,171.83,350,156.37,330l.59-7,12-2.77c15.74,20.35,54.23,33.23,91.54,30.62,22.07-1.55,41.13-8.33,52.27-18.61L324.2,337l-.58,7c-14,12.88-36,21-62,22.8A157.41,157.41,0,0,1,237.45,366.63Z",
    style: {
      fill: "#77BBF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.45,366.63C203.23,363.76,171.83,350,156.37,330l.59-7,12-2.77c15.74,20.35,54.23,33.23,91.54,30.62,22.07-1.55,41.13-8.33,52.27-18.61L324.2,337l-.58,7c-14,12.88-36,21-62,22.8A157.41,157.41,0,0,1,237.45,366.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.31,313.42l-32.19,1.83,9.27,10.05c-11.15,10.28-30.2,17.06-52.28,18.61-37.3,2.61-75.8-10.27-91.53-30.62L157,323.05c15.46,20,46.86,33.72,81.08,36.59a157.4,157.4,0,0,0,24.19.18c26-1.82,48-9.92,62-22.8l9.27,10.05Z",
    style: {
      fill: "#77BBF9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.6c04506fee03a45431cbd77face90df8.svg";
export { ForwardRef as ReactComponent };